import disk from './disk/overview.json';
import lb from './lb/overview.json';
import vm from './vm/overview.json';

export default [disk, lb, vm];
